import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";
export default function PortofinoLatexPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-04.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-01.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-02.png",
    ],
    productName: "Portofino Latex",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/Portofino-Latex.png",
    descriptionTitle: "",
    descriptionText:
      "Portofino Latex is made with the finest quality individual Pocketed springs as core coupled with durable 100% Latex on top.",
    availableSizes: "7″ & 9″",
    category: { title: "Latex Series", link: "/latex-mattress/" },
    points: [
      "Finest quality individual Pocketed Springs",
      "Durable 100% Natural Belgium Latex top",
      "Tight Top construction",
      "Medium-firm mattress with excellent conforming support",
    ],
    featuresText: [
      "HD Eclipse Soft Foam For Quilting",
      "Natural Belgium Latex",
      "Turkish Insulating Cotton Felt",
      "Perimeter Foam Encasement",
      "Pocket Spring System",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-11.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-06.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-07.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-08.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-09.png",
      "https://eclipsemattress.in/assets/images/products/portofino-latex/Portofino-Latex-10.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/portofino-latex/warranty.png",
    price: "₹19,399 - ₹68,749",
    relatedProducts: [
      {
        title: "Natura Latex",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/natura-latex.jpg",
        link: "/latex-mattress/natura-latex/",
      },
      {
        title: "Princeton Latex",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/princeton-latex.jpg",
        link: "/latex-mattress/princeton-latex/",
      },
      {
        title: "Vienna ET",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/vienna-et.jpg",
        link: "/patent-series-mattress/vienna-et/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Portofino Latex Mattress | Eclipse International"
        description="Shop premium quality of latex mattress from Eclipse International with the finest quality individual Pocketed springs as core coupled with durable 100% Latex on top"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-portofinolatex.jpg"
      />

      <Productpage location={location} product={data} />
    </div>
  );
}
